import { alertUiAdminPages } from '@juvare/alert-ui/ui/features/classifiers-admin-pages';
import { getContactManagementAdminPages } from '@juvare/contact-management/ui/features/classifiers-admin-pages';
import { contactUsAdminPages } from '@juvare/contact-management/ui/features/contact-us/components/ContactUsAdminPages';
import { getCredentialingAdminPages } from '@juvare/credentialing/ui/features/classifiers-admin-pages';
import { UserState } from '@juvare/platform-sdk-react/types';
import { ConfigurationPageDef } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { useDefaultClassifierAdminPages } from '@juvare/platform-sdk-react/ui/features/default-classifiers';
import { getHanConfigurationPages } from './hanConfigurationPages';

const useConfigurationPagesUnsorted = (userState: UserState): ConfigurationPageDef[] => [
    ...getContactManagementAdminPages(userState),
    ...getCredentialingAdminPages(userState),
    ...useDefaultClassifierAdminPages(),
    ...contactUsAdminPages,
    ...alertUiAdminPages,
    ...getHanConfigurationPages(userState),
];

export const useConfigurationPages = (userState: UserState) =>
    [...useConfigurationPagesUnsorted(userState)].sort((a, b) => a.label.localeCompare(b.label));
